/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Preview_EnlargeInputs */

const en_mk_preview_enlarge = /** @type {(inputs: Mk_Preview_EnlargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlarge preview`)
};

const id_mk_preview_enlarge = /** @type {(inputs: Mk_Preview_EnlargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbesar tampilan`)
};

/**
* | output |
* | --- |
* | "Enlarge preview" |
*
* @param {Mk_Preview_EnlargeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_preview_enlarge = /** @type {((inputs?: Mk_Preview_EnlargeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Preview_EnlargeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_preview_enlarge(inputs)
	return en_mk_preview_enlarge(inputs)
});